import { fallbackHeroImage, heroOffsetTop, sectionTitleMap } from "../const/course";
import type { CohortItem, CourseFact, CoursePageMap, SharingItem } from "../type/course";

export function getSection<T>(pageMap: CoursePageMap, id: string): T {
  const section = pageMap.sections.find((item) => item.id === id);
  if (!section) throw new Error(`Section "${id}" is missing from the page map.`);
  return section.content as T;
}

export function getSectionTitle(pageMap: CoursePageMap, id: string): string {
  const section = pageMap.sections.find((item) => item.id === id);
  if (!section) return "";
  return sectionTitleMap[id] ?? section.title;
}

export function getSharingEmbedUrl(item: SharingItem): string {
  if (item.platform !== "vimeo") return `https://www.youtube.com/embed/${item.content}`;
  return `https://player.vimeo.com/video/${item.content}`;
}

export function getSharingPreviewImage(item: SharingItem, fallbackImage: string): string {
  if (item.platform !== "vimeo") return `https://img.youtube.com/vi/${item.content}/hqdefault.jpg`;
  return fallbackImage;
}

export function getFeaturedSharingItem(sharingItems: SharingItem[], itemRef?: string): SharingItem {
  const refIndex = Number(itemRef?.match(/\[(\d+)\]/)?.[1] ?? "0");
  const featuredItem = sharingItems[refIndex];
  if (featuredItem) return featuredItem;
  return sharingItems[0];
}

export function scrollToSection(sectionId: string) {
  const section = document.getElementById(sectionId);
  if (!section) return;

  const sectionTop = section.getBoundingClientRect().top + window.scrollY - heroOffsetTop;
  window.scrollTo({ top: Math.max(sectionTop, 0), behavior: "smooth" });
}

export function getFactValue(facts: CourseFact[], key: string): string {
  const targetFact = facts.find((item) => item.key === key);
  if (!targetFact) return "";
  return targetFact.value;
}

export function getHeroImage(cohorts: CohortItem[]): string {
  return cohorts.find((item) => item.coverImage)?.coverImage ?? fallbackHeroImage;
}
